import ComplianceInformationStep from './ComplianceInformationStep.vue'
import { complianceInformationDescriptor } from './descriptor'
import { createComplianceInformationController } from './compliance-information-controller'
import ComplianceInformationStepV2 from './ComplianceInformationStepV2.vue'
import { complianceInformationV2Descriptor } from './descriptor-v2'
import { createComplianceInformationV2Controller } from './compliance-information-v2-controller'
import { createComplianceInformationV2ReviewContribution } from './review-contribution-v2'

const complianceInformationStepImplementation = Object.freeze({
    descriptor: complianceInformationDescriptor,
    component: ComplianceInformationStep,
    createController: createComplianceInformationController,
})

const complianceInformationV2StepImplementation = Object.freeze({
    descriptor: complianceInformationV2Descriptor,
    component: ComplianceInformationStepV2,
    createController: createComplianceInformationV2Controller,
    createReviewContribution: createComplianceInformationV2ReviewContribution,
})

export {
    ComplianceInformationStep,
    ComplianceInformationStepV2,
    complianceInformationDescriptor,
    complianceInformationStepImplementation,
    complianceInformationV2Descriptor,
    complianceInformationV2StepImplementation,
    createComplianceInformationController,
    createComplianceInformationV2Controller,
    createComplianceInformationV2ReviewContribution,
}
